let bank_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'banks', name: 'banks.list', component: () => import('./pages/Index.vue') },
      { path: 'banks/create', name: 'banks.create', component: () => import('./pages/Create.vue') },
      { path: 'banks/:id/edit', name: 'banks.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default bank_routes;
